import { Component, OnInit } from '@angular/core';
import { Observable, of } from 'rxjs';
import { OpportunityDiaryNoteDetailsComponent } from '../details/opportunity-diary-note-details.component';
import { DiaryNote } from '@features/diary-notes/model/diary-note';
import { DiaryNoteService } from '@features/diary-notes/services/diary-note.service';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-opportunity-diary-note-new',
  templateUrl: '../details/opportunity-diary-note-details.component.html'
})
export class OpportunityDiaryNoteNewComponent
  extends OpportunityDiaryNoteDetailsComponent
  implements OnInit
{
  get isNewDiaryNote(): boolean {
    return true;
  }

  constructor(
    oppDiaryNoteService: DiaryNoteService,
    protected fb: FormBuilder
  ) {
    super(oppDiaryNoteService, fb);
  }

  get saveLabel(): string {
    return 'Add';
  }

  get title(): string {
    return 'Add Diary Note';
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  content(): Observable<DiaryNote.Model> {
    return of({} as DiaryNote.Model);
  }
}
